/* eslint-disable react/no-unused-prop-types */
import { Component } from 'react';
import PropTypes from 'prop-types';
import handleInputChange from '%/utils/handleInputChange';
import { getPayload } from '%/utils/forms/getPayload';
import validationFactory from '%/utils/validation';
import { mask } from '%/utils/formUtils/maks/mask';
import { updateURLWithActiveVersion, getVersionSlug } from '%/utils/urlHandler';
import { setRecaptchaLoadOnFormFocus } from '%/utils/reCAPTCHA';
import FormWrapper from '../FormComponents/FormWrapper';
import FormHeader from '../FormComponents/FormHeader';
import FormBody from '../FormComponents/FormBody';
import FieldGroup from '../FormComponents/FieldGroup';
import Input from '../FormComponents/Fields/Input';
import Checkbox from '../FormComponents/Fields/Checkbox';
import Select from '../FormComponents/Fields/Select';
import FormFooter from '../FormComponents/FormFooter';
import SubmitButton from '../FormComponents/SubmitButton';
import ContactFieldGroup from '../FormComponents/Fields/ContactFieldGroup';
import VehicleInExchangeFieldGroup from '../FormComponents/Fields/VehicleInExchangeFieldGroup';
import FormMessageOverlay from '../../FormMessageOverlay';

export default class PerformanceConversionForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: null,
      email: null,
      phone: null,
      cpf: '',
      unit: null,
      'veiculo-na-troca': null,
      mailing: null,
      whatsapping: null,
      phoning: null,
      activeVersion: this.props.versions && this.props.versions[0],
      selectedVariant: this.props.versions && this.props.versions[0].slug,
      dataPermissions: false,
      formState: {
        isSubmitting: false,
        errorSending: false,
        showOverlay: false,
      },
    };

    this.handleInputChange = handleInputChange.bind(this);
    this.handleCloseOverlay = this.handleCloseOverlay.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleVersionChange = this.handleVersionChange.bind(this);
    this.versionsToSelect = this.versionsToSelect.bind(this);
    this.contactOptionsIsInvalid = this.contactOptionsIsInvalid.bind(this);
  }

  componentDidMount() {
    if (this.phoneInput) {
      mask(this.phoneInput, { mask: 'phone' }, phoneMaskvalue =>
        this.setState({ phone: phoneMaskvalue }),
      );
    }

    if (this.cpfInput) {
      mask(this.cpfInput, { mask: 'cpf' }, cpfMaskValue =>
        this.setState({ cpf: cpfMaskValue }),
      );
    }

    this.validator = validationFactory(`#${this.props.formId}`);

    this.getVersionFromURL();

    setRecaptchaLoadOnFormFocus();
  }

  handleVersionChange(event) {
    this.handleInputChange(event);

    this.setState(prevState => {
      const activeVersion = this.findVersionBySlug(prevState.selectedVariant);
      updateURLWithActiveVersion(activeVersion.slug);
      return { activeVersion };
    });
  }

  handleCloseOverlay() {
    this.setState({ formState: { showOverlay: false } });
  }

  handleSubmit(event) {
    event.preventDefault();

    if (this.contactOptionsIsInvalid()) {
      this.setState({ showContactError: true });

      return;
    }

    const invalidInputs = this.validator.validateAll(this.form);
    const formIsValid = invalidInputs.length === 0;
    if (!formIsValid) return;

    const payload = getPayload(this.state, this.props);

    this.setState({
      formState: { isSubmitting: true },
    });

    window.serviceConversion
      .convert(payload)
      .then(() => {
        this.setState({
          formState: {
            isSubmitting: false,
            errorSending: false,
          },
        });
        return {
          data: payload,
          status: 'success',
        };
      })
      .catch(error => {
        this.setState({
          formState: {
            isSubmitting: false,
            errorSending: true,
          },
        });
        console.error(error);
        return {
          data: error,
          status: 'error',
        };
      })
      .then(result => {
        document.dispatchEvent(
          new CustomEvent('new_conversion', {
            detail: {
              status: result.status,
              data: result.data,
            },
          }),
        );
        this.setState({
          formState: { showOverlay: true },
        });
      });
  }

  getVersionFromURL() {
    const versionSlug = getVersionSlug();
    if (!versionSlug) return;

    const activeVersion = this.findVersionBySlug(versionSlug);
    this.updateVersion(activeVersion);
  }

  contactOptionsIsInvalid() {
    const { mailing, whatsapping, phoning } = this.state;
    const { showContactError } = this.props;

    if (!showContactError) {
      return false;
    }

    return !mailing && !whatsapping && !phoning;
  }

  versionsToSelect() {
    return this.props.versions.map(version => ({
      label: version.name,
      value: version.slug,
      selected: version.slug === this.state.selectedVariant,
    }));
  }

  updateVersion(version) {
    this.setState({
      activeVersion: version,
      selectedVariant: version.slug,
    });
  }

  findVersionBySlug(slug) {
    return this.props.versions.find(version => version.slug === slug);
  }

  render() {
    const {
      formId,
      showEmail,
      showCpf,
      showUnits,
      showVehicleInExchangeField,
      showDataPermissions,
      dataPermissionsCustomText,
      linkPrivacyPolicy,
      showSelectVariant,
      versions,
    } = this.props;

    return (
      <div className="conversion-form">
        <FormWrapper
          customClasses="conversion-form__wrapper"
          formId={formId}
          setRef={form => {
            this.form = form;
          }}
          handleSubmit={this.handleSubmit}
        >
          <FormMessageOverlay
            handleClose={this.handleCloseOverlay}
            isVisible={this.state.formState.showOverlay}
            type={this.state.formState.errorSending ? 'error' : 'success'}
          />
          <FormHeader
            customClasses="conversion-form__header"
            title="Estou Interessado"
          />
          <FormBody>
            <p className="conversion-form__subtitle">
              Preencha o formulário abaixo para receber o contato de um de
              nossos especialistas:
            </p>
            <FieldGroup>
              {showSelectVariant && versions && (
                <Select
                  name="selectedVariant"
                  options={this.versionsToSelect()}
                  handleChange={this.handleVersionChange}
                  value={this.selectedVariant}
                />
              )}
              <Input
                title="Nome"
                name="name"
                value={this.state.name}
                type="text"
                placeholder="Nome"
                handleChange={this.handleInputChange}
                required
              />
              {showEmail && (
                <Input
                  title="E-mail"
                  name="email"
                  value={this.state.email}
                  type="email"
                  placeholder="E-mail"
                  handleChange={this.handleInputChange}
                  required
                />
              )}
              <Input
                title="Telefone"
                name="phone"
                value={this.state.phone}
                type="phone"
                autoComplete="off"
                placeholder="Telefone/Whatsapp"
                handleChange={this.handleInputChange}
                setRef={phoneInput => {
                  this.phoneInput = phoneInput;
                }}
                required
              />
              {showCpf && (
                <Input
                  title="CPF"
                  name="cpf"
                  value={this.state.cpf}
                  type="text"
                  placeholder="CPF"
                  handleChange={this.handleInputChange}
                  setRef={cpfInput => {
                    this.cpfInput = cpfInput;
                  }}
                  required
                  minLength={14}
                />
              )}
              {showUnits && (
                <Select
                  name="unit"
                  options={this.props.units}
                  label="Escolha a unidade:"
                  placeholder="Selecione uma unidade"
                  handleChange={this.handleInputChange}
                />
              )}
            </FieldGroup>
            {showVehicleInExchangeField ? (
              <VehicleInExchangeFieldGroup
                handleChange={this.handleInputChange}
              />
            ) : null}
            <ContactFieldGroup
              handleChange={this.handleInputChange}
              mailing={this.state.mailing}
              whatsapping={this.state.whatsapping}
              phoning={this.state.phoning}
              showError={this.state.showContactError}
            />
            {showDataPermissions && (
              <FieldGroup>
                <Checkbox
                  label={dataPermissionsCustomText}
                  name="dataPermissions"
                  value={this.state.dataPermissions}
                  isChecked={this.state.dataPermissions}
                  customClasses="form__field-checkbox-data-permissions"
                  handleChange={this.handleInputChange}
                />
              </FieldGroup>
            )}
            <FormFooter linkPrivacyPolicy={linkPrivacyPolicy} />
            <SubmitButton
              label="Enviar"
              isSubmitting={this.state.formState.isSubmitting}
            />
          </FormBody>
        </FormWrapper>
      </div>
    );
  }
}

PerformanceConversionForm.defaultProps = {
  showEmail: true,
  showVehicleInExchangeField: true,
  showContactError: false,
};

PerformanceConversionForm.propTypes = {
  formId: PropTypes.string,
  cloneId: PropTypes.string,
  linkPrivacyPolicy: PropTypes.string,
  product: PropTypes.string,
  channel: PropTypes.string,
  category: PropTypes.string,
  brand: PropTypes.string,
  showSelectVariant: PropTypes.bool,
  showVariantImage: PropTypes.bool,
  modelYear: PropTypes.string,
  showEmail: PropTypes.bool,
  showCpf: PropTypes.bool,
  showUnits: PropTypes.bool,
  showVehicleInExchangeField: PropTypes.bool,
  showDataPermissions: PropTypes.bool,
  dataPermissionsCustomText: PropTypes.string,
  versions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
      slug: PropTypes.string,
    }),
  ),
  units: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  showContactError: PropTypes.bool,
};
